/**
 * Labstep
 *
 * @module components/ProtocolCollection/Action/Delete
 * @desc Button to delete protocol collection
 */

import { EntityActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import type React from 'react';
import type { IProtocolCollectionActionDeleteProps } from './types';

export const ProtocolCollectionActionDelete: React.FC<
  IProtocolCollectionActionDeleteProps
> = ({ protocolCollection, ...rest }) => (
  <EntityActionDelete {...rest} entity={protocolCollection} />
);
